import type { JobPostingEntitlement } from '../../../../reducers/entitlement/entitlement'
import type { JobPostingPackage } from '../../../../reducers/packages/packages'

import type { SiteAlias } from '../../../../../schema/webshop-package'
import listsAreEqual from '../../../../../util/lists-are-equal/listsAreEqual'
import { packageDefinitionsAreEqual } from '../../../../../util/get-definition/getDefinition'

/**
 * Returns entitlements that:
 * - can be used for products on a specific site AND
 * - do not appear in the list of available job posting packages so that the return value of
 * this function contains a list of entitlements that can be joined with the list of available
 * job posting packages to show a complete list of possible job postings to the recruiter
 */
const getEntitlementsNotMatchingJobPostings = (
  jobPostingEntitlements: JobPostingEntitlement[],
  jobPostingPackages: JobPostingPackage[],
  selectedSites: SiteAlias[],
): JobPostingEntitlement[] => jobPostingEntitlements
  .filter((entitlement: JobPostingEntitlement) =>
    listsAreEqual(entitlement.product.publishOn, selectedSites),
  )
  .filter(
    (entitlement: JobPostingEntitlement) =>
      !jobPostingPackages.find((jobPostingPackage: JobPostingPackage) =>
        // @ts-ignore
        packageDefinitionsAreEqual(jobPostingPackage, entitlement),
      ),
  )

export default getEntitlementsNotMatchingJobPostings
